var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 2.00004V5.00004M0.5 5.00004H3.5M0.5 5.00004L2.82 2.82004C3.35737 2.28239 4.02219 1.88964 4.7524 1.67842C5.48262 1.46721 6.25445 1.44441 6.99586 1.61217C7.73727 1.77992 8.4241 2.13275 8.99227 2.63775C9.56043 3.14274 9.99142 3.78343 10.245 4.50004M11.5 10V7.00004M11.5 7.00004H8.5M11.5 7.00004L9.18 9.18004C8.64263 9.71768 7.97781 10.1104 7.2476 10.3217C6.51738 10.5329 5.74555 10.5557 5.00414 10.3879C4.26273 10.2202 3.5759 9.86732 3.00773 9.36233C2.43957 8.85734 2.00858 8.21664 1.755 7.50004",
    stroke: "#005BD3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh_icon.744ec31a76593f6f81ace9f68baf2d73.svg";
export { ForwardRef as ReactComponent };